module.exports = __webpack_public_path__ + "img/khzx.ede20b2a.png";